var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBorrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#999;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M480.894,105.893a.639.639,0,0,1-.451-1.09L495.166,90.08a.638.638,0,0,1,.9.9l-14.723,14.723A.636.636,0,0,1,480.894,105.893Z",
    transform: "translate(-480.256 -89.893)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M495.618,105.893a.636.636,0,0,1-.451-.187L480.443,90.983a.638.638,0,0,1,.9-.9L496.069,104.8a.639.639,0,0,1-.452,1.09Z",
    transform: "translate(-480.256 -89.893)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorrar);
export default __webpack_public_path__ + "static/media/borrar.7ad715c32a48e873eaa865a6d7dc8d60.svg";
export { ForwardRef as ReactComponent };